var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyStorageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z",
    stroke: "#2555FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2V8H20",
    stroke: "#2555FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95054 14.8411C9.66146 14.12 9.63021 13.3213 9.86206 12.5799C10.0939 11.8384 10.5747 11.1998 11.223 10.7719C11.8714 10.344 12.6476 10.1531 13.4205 10.2314C14.1934 10.3098 14.9155 10.6526 15.4648 11.2019C16.0141 11.7512 16.3569 12.4733 16.4352 13.2462C16.5136 14.0191 16.3227 14.7953 15.8948 15.4436C15.4669 16.092 14.8282 16.5727 14.0868 16.8046C13.3454 17.0364 12.5466 17.0052 11.8256 16.7161L11.8256 16.716L11.2084 17.3333L10.0834 17.3333L10.0834 18.4583L8.95837 18.4583L8.95837 19.5833L7.08337 19.5833L7.08337 17.7083L9.95062 14.841L9.95054 14.8411Z",
    stroke: "#2555FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9166 13.0833C14.1007 13.0833 14.25 12.9341 14.25 12.75C14.25 12.5659 14.1007 12.4167 13.9166 12.4167C13.7325 12.4167 13.5833 12.5659 13.5833 12.75C13.5833 12.9341 13.7325 13.0833 13.9166 13.0833ZM14.9166 12.75C14.9166 13.3023 14.4689 13.75 13.9166 13.75C13.3643 13.75 12.9166 13.3023 12.9166 12.75C12.9166 12.1977 13.3643 11.75 13.9166 11.75C14.4689 11.75 14.9166 12.1977 14.9166 12.75Z",
    fill: "#2555FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyStorageIcon);
export default __webpack_public_path__ + "static/media/key-storage-icon.baeb08be.svg";
export { ForwardRef as ReactComponent };